const VideoSkeleton = () => <div className="h-60 animate-pulse bg-gray-300 md:h-96" data-sentry-component="VideoSkeleton" data-sentry-source-file="VideoSkeleton.jsx" />;
export default VideoSkeleton;